import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { NavLink, useNavigate } from "react-router";
import styled from "styled-components";

import ListParameterGroups from "./ListParameterGroups.graphql";
import { confirmUnsavedChanges } from "../../../modules/unsaved-changes";

const StyledList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 4px;
    list-style: none;
    margin: 0;
    padding: 0;

    li {
        a {
            align-items: center;
            border-left: 3px solid transparent;
            border-radius: 4px;
            color: #172b4d;
            display: flex;
            font-size: 0.9rem;
            justify-content: space-between;
            padding: 8px 12px;
            text-decoration: none;
            transition: all 0.15s;

            &:hover {
                background: #f4f5f7;
            }

            &.active {
                background: #deebff;
                border-left-color: #0052cc;
                color: #0747a6;
                font-weight: 600;
            }
        }
    }
`;

export default function ParameterGroupList(props) {
    const { guard } = props;
    const navigate = useNavigate();

    const listParameterGroups = useQuery(gql(ListParameterGroups));

    if (listParameterGroups.loading) return "loading";
    if (listParameterGroups.error) return "error";

    const sortedGroups = listParameterGroups.data.parameterGroups.slice().sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

    async function open(event, itemID) {
        if (!guard) return;
        event.preventDefault();
        if (await confirmUnsavedChanges(guard)) {
            navigate(itemID);
        }
    }

    return (
        <StyledList>
            { sortedGroups.map((parameterGroup) => (
                <li key={ parameterGroup.id }>
                    <NavLink
                        onClick={ (e) => open(e, parameterGroup.id) }
                        to={ parameterGroup.id }
                    >
                        <span>{ parameterGroup.name[0]?.text ?? parameterGroup.id }</span>
                    </NavLink>
                </li>
            )) }
        </StyledList>
    );
}
